export default () => ({
  root: {
    position: 'relative',
    height: '100%',
    width: '100%',
  },
});
